import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';
import { map, filter } from 'rxjs/operators';
import { InvoiceStatus } from '@mandae/catalogo';
import { UIRouter } from '@uirouter/core';
import { UiRouterState } from 'src/app/services/ajs-router-state.service';
import {LocalStorageService} from "../../services/localstorage.service";
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'mandae-home-financial',
  templateUrl: './financial.component.html',
  styleUrls: ['./financial.component.scss']
})
export class FinancialComponent implements OnInit {

  public showLastInvoice = false;
  public showMonthlySpendings = false;

  public statusLastInvoice: number;
  public dueDateLastInvoice: Date;
  private totalLastInvoice: number;
  private totalMonthlySpending: number;

  public get intMonthlySpendings() {
    return Math.floor(this.totalMonthlySpending);
  }
  public get centsMonthlySpendings() {
    return Math.floor((this.totalMonthlySpending - Math.floor(this.totalMonthlySpending)) * 100);
  }

  public get intLastInvoice() {
    return Math.floor(this.totalLastInvoice);
  }
  public get centsLastInvoice() {
    return Math.floor((this.totalLastInvoice - Math.floor(this.totalLastInvoice)) * 100);
  }

  private URL_GASTO_MENSAL_DASHBOARD: string =
    environment.angularJSconstants.URL_SERVICO_FISCAL;

  private URL_FATURAS_CLIENTE: string =
    environment.angularJSconstants.URL_SERVICO_FISCAL;

  constructor(
    private state: UiRouterState,
    private http: HttpClient,
    private localStorageService: LocalStorageService
    ) { }

  async ngOnInit() {

    // Última fatura do cliente via stack novo (bff-billing). O seller-bff resolve o
    // cliente pelo token; o /v2/faturas ordena por dataHoraCriacao DESC, então
    // limit=1 devolve a fatura mais recente. limit/offset são obrigatórios no v2.
    this.http.get<any>(
      `${this.URL_FATURAS_CLIENTE}/v2/faturas`,
      { params: { situacao: '1,2,3,4,5,7,9', limit: '1', offset: '0' }, responseType: 'json' }
    )
    .pipe(
      map(invoices => _.head(invoices.data)),
      filter(invoice => !!invoice)
    ).subscribe((invoice: any) => {
      this.statusLastInvoice = +invoice.situacao;
      this.dueDateLastInvoice = invoice.dataVencimento;
      this.totalLastInvoice = invoice.total;
    });

    const monthlySpending = await this.getGastoMensal(moment().format('YYYY-MM'));
    this.totalMonthlySpending = monthlySpending.gastoDiario.reduce((total, curr) => total + curr.valor, 0.0);
  }

  public async getGastoMensal(mesReferencia): Promise<any> {
    const user = this.localStorageService.get("user");
    return this.http
      .get(
        `${this.URL_GASTO_MENSAL_DASHBOARD}/v2/extratos/mensal/detalhado?referenceMonth=${mesReferencia}&clientId=${user.id}`,
        { responseType: 'json' }
      )
      .toPromise();
  }

  goToFinancialPanel() {
    this.state.go('dashboard');
  }

  getInvoiceStatusClass() {
    const invoiceStatus = InvoiceStatus.fromValue<InvoiceStatus>(this.statusLastInvoice);
    let status = 'status-info';

    if (!!invoiceStatus) {
      switch (invoiceStatus.code) {
        case 'Paga': status = 'status-success'; break;
        case 'Vencida': status = 'status-danger'; break;
        case 'NaoPaga': status = 'status-info'; break;
        case 'Reembolsada': status = 'status-warning'; break;
      }
    }

    return 'status tag ' + status;
  }

  setShowLastInvoice(value: boolean) {
    this.showLastInvoice = value;
  }

  setShowMonthlySpendings(value: boolean) {
    this.showMonthlySpendings = value;
  }
}
